import { createFeature, createReducer, on } from '@ngrx/store';
import { ProjectPermitTaskServiceCreateResponseJson } from '@vmspdb/definitions';
import { PaginatedPermitTaskActions } from './paginated-permit-task.actions';

export const paginatedPermitTaskFeatureKey = 'paginatedPermitTask';

export interface PaginatedPermitTaskState {
  items: ProjectPermitTaskServiceCreateResponseJson[];
  loading: boolean;
  total: number;
  page: number;
  error: any;
}

export const initialState: PaginatedPermitTaskState = {
  items: [],
  total: 0,
  page: 0,
  loading: false,
  error: undefined,
};

export const reducer = createReducer(
  initialState,
  on(
    PaginatedPermitTaskActions.listPaginatedPermitTasks,
    (state): PaginatedPermitTaskState => ({ ...state, loading: true }),
  ),
  on(
    PaginatedPermitTaskActions.listPaginatedPermitTasksSuccess,
    (state, { data }): PaginatedPermitTaskState => ({
      ...state,
      ...data,
      ...data.pagination,
      total: Number(data.pagination?.total),
      loading: false,
    }),
  ),
  on(
    PaginatedPermitTaskActions.listPaginatedPermitTasksFailure,
    (state, { error }): PaginatedPermitTaskState => ({
      ...state,
      error,
      loading: false,
    }),
  ),
);

export const paginatedPermitTaskFeature = createFeature({
  name: paginatedPermitTaskFeatureKey,
  reducer,
});
